<script>
  import { ShopboxDashboard } from '@shopboxai/shopbox-dashboard-app';
  import { userToken, currentUser } from '../stores';
</script>

<ShopboxDashboard user={$currentUser} currentClient={$currentUser.clientId} />
